export const facebookConfig = {
  appId: '491377580890739',
  version: 'v3.1',
  sdkNoUrl: 'https://connect.facebook.com/nb_NO/sdk.js',
  sdkEnUrl: 'https://connect.facebook.com/en_US/sdk.js',
  sdkDebugUrl: 'https://connect.facebook.net/en_US/sdk/debug.js'
};
